import { ServiceFieldType } from '@onlog-public/additional-services-types';
import { AdditionServicesOptionsState } from '@pages/AdditionalServices/containers/additionServicesOptionsContext';
import optionsLoader from '@pages/AdditionalServices/containers/services/optionsLoader';
import { OptionsCache } from '@pages/AdditionalServices/containers/services/optionsLoader/types';
import {
  AServiceCache,
  AServicePropertyCache,
  AServicePropertyFilterAndOrder,
  AdditionServicesState,
} from '@pages/AdditionalServices/containers/types';

import { ServiceData, SetUpServiceData } from '../../../basket/types';
import {
  exportContractors,
  filterData,
  getInitialEntityID,
  getUnloadedEntityID,
} from '../../../loadServiceDataCache';
import { serviceRestoreStateGeneratorProcessor } from '../types';

/**
 * ServiceCacheProcessor формирует кэш сущностей различного типа для использования в формировании опций
 * для полей дополнительных услуг
 */
export class ServiceCacheProcessor implements serviceRestoreStateGeneratorProcessor {
  /**
   * restore выполняет восстановление стейтов. Возвращает все стейты.
   * @param _
   * @param __
   * @param additionalServiceState
   * @param optionsState
   * @param serviceCacheState
   * @param servicePropertyCacheState
   * @param servicePropertyFilterAndOrderState
   */
  async restore(
    _: SetUpServiceData,
    __: (SetUpServiceData | ServiceData)[],
    additionalServiceState: AdditionServicesState,
    optionsState: AdditionServicesOptionsState,
    serviceCacheState: AServiceCache,
    servicePropertyCacheState: AServicePropertyCache,
    servicePropertyFilterAndOrderState: AServicePropertyFilterAndOrder
  ) {
    // Добавляем данные директорий
    let serviceDataToLoad = exportContractors(
      additionalServiceState.Variants,
      getInitialEntityID()
    );

    // Добавляем данные услуг
    const allServices = Object.values(additionalServiceState.VariantServices)
      .map((s) => s.map((serv) => [serv, ...serv.additionServices]))
      .flat(2);

    serviceDataToLoad = exportContractors(allServices, serviceDataToLoad);

    // Добавляем данные ЦП
    Object.values(additionalServiceState.VariantsCalculationResult)
      .flat(1)
      .map((p) => {
        serviceDataToLoad.tax.push(String(p?.result?.data?.tax_id ?? ''));
        serviceDataToLoad.currency.push(String(p?.result?.data?.currency_id ?? ''));
      });

    // Чистим данные от мусора, если он есть
    Object.keys(serviceDataToLoad).map((k) => {
      serviceDataToLoad[k] = filterData(serviceDataToLoad[k]);
    });

    serviceDataToLoad.currency.push(additionalServiceState.CurrencyID);

    const entities = getUnloadedEntityID(serviceDataToLoad);
    const result = await Promise.all(
      Object.keys(entities).map(async (type: ServiceFieldType) => {
        if (entities[type].length === 0) {
          return { type, items: { isPartialLoading: true, cache: {} } as OptionsCache<any> };
        }

        return {
          type,
          items: await optionsLoader().LoadOptionsCache(type, entities[type]),
        };
      })
    );

    const newCache = { ...serviceCacheState.Cache };

    result.map((r) => {
      if (Object.keys(r.items.cache).length === 0) {
        return;
      }

      newCache[r.type] = {
        ...newCache[r.type],
        cache: { ...newCache[r.type].cache, ...r.items.cache },
      };
    });

    return {
      isValid: true,
      additionalServiceState,
      optionsState,
      serviceCacheState: {
        ...serviceCacheState,
        Cache: newCache,
      },
      servicePropertyCacheState,
      servicePropertyFilterAndOrderState,
    };
  }
}
